import React from 'react';
import classroomImage from '../assets/Fotografija_5-min.jpg';

const CoursesSection = ({toSection,section}) => {

    const scrollToForm = () => {
        const formElement = document.getElementById('contact-form');
        if (formElement) {
          formElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          });
        }
      };

  return (
    <div style={{marginTop:'-40px'}} id={section} className="relative">
      {/* Top wave */}
      <div style={{zIndex:1}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="#e6f4ff"
            fillOpacity="1" 
            d="M0,160L48,144C96,128,192,96,288,80C384,64,480,64,576,80C672,96,768,128,864,128C960,128,1056,96,1152,80C1248,64,1344,64,1392,64L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>

      <div   className="bg-[#002147] min-h-[90vh] relative py-20">
        {/* Stars background could be added here */}
        <div className="container mx-auto px-4">
          {/* Content remains the same */}
          <div className="max-w-4xl mx-auto text-center mb-16">
            <h2 className="font-['Grandstander'] pt-10 text-white text-4xl font-extrabold mb-8">
            7 Year-Long Courses and More than 250 STEAM Lessons
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mx-auto">
            <div className="bg-white p-4 rounded-2xl overflow-hidden shadow-xl">
              <img 
                src={classroomImage}
                alt="Tinker Labs Classroom" 
                className="w-full h-auto rounded-xl"
              />
            </div>

            <div className="text-white space-y-6 font-['Lexend']">
              <p className="text-lg leading-relaxed">
              With Tinker Labs, every lesson is a chance to learn about the way the world works, whether you are 3 years old, or 14, our classes are designed to teach you about science, technology, engineering, art and math through age appropriate activities that children enjoy.
              </p>
              
              <p className="text-lg leading-relaxed">
              Our programs are created with an emphasis on practical learning through play, with an average of 4 experiemets per lesson, so that children see it as fun and retain knowledge fast and with ease
              </p>
              
              <p className="text-lg leading-relaxed">
              Learning in small groups of up to only 10 students allows us to personalize the curriculum to tailor it to each child.
              </p>

              <div className="pt-4 font-['Lexend']">
                <button onClick={scrollToForm} className="bg-[#F18917] text-white px-8 py-3 rounded-full font-['Lexend'] font-semibold hover:bg-[#FF5A1F] transition-all">
                  Request a Franchise Informational Brochure
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom wave - updated to match the design */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '120px' }}
        >
          <defs>
            <linearGradient id="waveGradient" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#B8E1FF" />
              <stop offset="100%" stopColor="#FFFFFF" />
            </linearGradient>
          </defs>
          <path 
            fill="url(#waveGradient)"
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default CoursesSection;